import React, { useContext, useEffect, useState } from 'react'
import './Login.css'
import { StoreContext } from '../../context/StoreContex'
import axios from 'axios'
import { useNavigate } from "react-router-dom";


const Login = ({ setShowLogin }) => {

    const { token, setToken, backendUrl, loginState, setLoginState } = useContext(StoreContext);
    const [currState, setCurrState] = useState("Check Email");
    const [name, setName] = useState("");  
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();


    const onSubmitHandler = async (event) => {
        event.preventDefault();
        try {


            if (currState === "Check Email") {

                try {
                    const response = await axios.post(backendUrl + '/checkUser', { email }, { headers: { Authorization: "Bearer " + token } });

                    if (response.status === 200) {
                        setCurrState("Enter Password")
                    }

                } catch (error) {
                    console.log("Error:", error.response?.data || error.message);
                    if (error.response?.data.code === 3) {
                        setCurrState("Sign Up")

                    }
                }


            }

            if (currState === "Enter Password") {

                try {
                    const response = await axios.post(backendUrl + '/login', { email, password }, { headers: { Authorization: "Bearer " + token } });

                    if (response.status === 200) {
                        const newToken = await response.data.data.token;
                        setToken(newToken);
                        localStorage.setItem('token', newToken);
                        setLoginState("Login")
                        navigate("/");

                    }

                } catch (error) {
                    console.log("Error:", error.response?.data || error.message);

                }


            }
            if (currState === "Sign Up") {

                try {
                    const response = await axios.post(backendUrl + '/addUser', { email, password, phone,name }, { headers: { Authorization: "Bearer " + token } });

                    if (response.status === 200) {
                        const newToken = await response.data.data.jwt;
                        setToken(newToken);
                        localStorage.setItem('token', newToken);
                        setLoginState("Login")
                        navigate("/");

                    }

                } catch (error) {
                    console.log("Error:", error.response?.data || error.message);

                }


            }





        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className='login-popup' id=''>
            <form onSubmit={onSubmitHandler} className='login-popup-container'>
                <div className="login-popup-title">
                    <h2>{currState}</h2>

                </div>
                <div className='login-popup-inputs'>
                    <input onChange={(e) => setEmail(e.target.value)} value={email} type='email' placeholder='Your Email' required />

                    {
                        currState === "Sign Up" ?
                        <><input onChange={(e) => setName(e.target.value)} value={name} type='text' placeholder='Your Name' required />
                            <input onChange={(e) => setPhone(e.target.value)} value={phone} type='text' placeholder='Your Mobile Number' required /></>
                            : <></>
                    }
                    {
                        currState === "Enter Password" || currState === "Sign Up" ?
                            <input onChange={(e) => setPassword(e.target.value)} value={password} type='password' placeholder='Password' required />
                            : <> </>
                    }


                </div>
                <button>{currState === "Sign Up" ? "Create account" : "Check Email"}</button>
                {currState === "Check Email" ? <></> : <> <div className='login-popup-condition'>
                    <input type="checkbox" required />
                    <p>By continuning, i agree to the trems of the use & privacy policy</p>
                </div></>}


            </form>
        </div>
    )
}

export default Login